import React from 'react'
import './Gallery.scss';
import salad from '../../../Assets/Images/salad-1024x1024.jpg';
import pumpkinSoup from '../../../Assets/Images/pumpkin-soup-1024x1024.jpg';
import brookeLark from '../../../Assets/Images/brooke-lark-1024x1024.jpg';
import musselsBlacktable from '../../../Assets/Images/mussels-blacktable-1024x1024.jpg';
import barmenCoctail from '../../../Assets/Images/barmen-coctail-1024x1024.jpg';
import foodPlate from '../../../Assets/Images/food-plate-1024x1024.jpg';
import glassOrangeCoctail from '../../../Assets/Images/glass-orange-coctail-1-1024x1024.jpg';
import saladWine from '../../../Assets/Images/salad-wine-1024x1024.jpg';
import restaurantTable from '../../../Assets/Images/restaurant-table-1024x1024.jpg';
import desertApple from '../../../Assets/Images/desert-apple-1024x1024.jpg';

export default function Gallery() {
  return (
    <div>
      <section className='subBanner textCenter'>
          <div className='middle_box'>
            <h1>Gallery</h1>
          </div>
      </section>
      <section className='sectionPadding welcome_wrap aboutUs_wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 textCenter'>
                <div className='gallery_box_inner'>
                    <div class="titleBox mt-0">
                        <span>Gallery</span>
                        <h2>Otlo The Cafe Restaurant</h2>
                    </div>
                    <p>Since 2014 our plan has been simple – serve great food and drink in a comfortable and stylish environment with the added advantage of beautiful bedrooms to relax in. Our ethos is a straight forward one: we want everyone to leave happy, and we’ll do our absolute best to make it happen!</p>
                </div>
            </div>
          </div>
        </div>
        </section>
        <section className='maingallery'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3 p-0'>
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={salad} />
                            <div className='info'>
                                <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                                <h4>Classic CheeseCake</h4>
                                <p>Seasonal Flavours</p>
                            </div>
                            </a>           
                        </div>
                    </div>
                    <div className='col-md-3 p-0'>                        
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={pumpkinSoup} />
                            <div className='info'>
                                <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                                <h4>Caesar Salad</h4>
                            </div>
                            </a>           
                        </div>
                    </div>
                    <div className='col-md-6 p-0'>                        
                        <div className='gallery_box'>
                            <a href='#'>
                            <img className='bigImage' src={brookeLark} />
                            <div className='info'>
                                <span className='sub-title'>Fish</span>
                                <h4>Salmon Tartare</h4>
                                <p>Chef's Menu</p>
                            </div>
                            </a>           
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-3 p-0'>                        
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={musselsBlacktable} />
                            <div className='info'>
                                <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                                <h4>Seared Halloumi Cheese</h4>
                                <p>Seasonal Flavours</p>
                            </div>
                            </a>           
                        </div>
                    </div>
                    <div className='col-md-3 p-0'>
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={barmenCoctail} />
                            <div className='info'>
                                <span className='sub-title'>Events</span>
                                <h4>Beef CheeseBurger</h4>
                                <p>Brunch</p>
                            </div>
                            </a>           
                        </div>                        
                    </div>
                    <div className='col-md-3 p-0'>
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={foodPlate} />
                            <div className='info'>
                                <span className='sub-title'>Dessert / Events / Meat</span>
                                <h4>Tuna Salad</h4>
                                <p>Seasonal Flavours</p>
                            </div>
                            </a>           
                        </div>    
                    </div>
                    <div className='col-md-3 p-0'>                        
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={glassOrangeCoctail} />
                            <div className='info'>
                                <span className='sub-title'>Meat</span>
                                <h4>Duck Confit</h4>
                            </div>
                            </a>           
                        </div>  
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 p-0'>                        
                        <div className='gallery_box'>
                            <a href='#'>
                            <img className='bigImage' src={saladWine} />
                            <div className='info'>
                                <span className='sub-title'>Events / Fish / Meat</span>
                                <h4>Nordic Shrimp Roll</h4>
                                <p>Chef's Menu</p>
                            </div>
                            </a>           
                        </div>  
                    </div>
                    <div className='col-md-3 p-0'>
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={restaurantTable} />
                            <div className='info'>
                                <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                                <h4>Classic CheeseCake</h4>
                                <p>Seasonal Flavours</p>
                            </div>
                            </a>           
                        </div>                          
                    </div>
                    <div className='col-md-3 p-0'>
                        <div className='gallery_box'>
                            <a href='#'>
                            <img src={desertApple} />
                            <div className='info'>
                                <span className='sub-title'>Events</span>
                                <h4>Chocolate Brownie</h4>
                                <p>Seasonal Flavours</p>
                            </div>
                            </a>           
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}
